
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partners/[partner]/ready-program",
      function () {
        return require("private-next-pages/partners/[partner]/ready-program.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/partners/[partner]/ready-program"])
      });
    }
  